import { render, staticRenderFns } from "./goodsTags.vue?vue&type=template&id=1603d4bd&"
import script from "./goodsTags.vue?vue&type=script&lang=ts&"
export * from "./goodsTags.vue?vue&type=script&lang=ts&"
import style0 from "./goodsTags.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports